export default __webpack_public_path__ + "static/book-e145b52eb23597c06f852c9ed36a4cd2.png";